<template>
  <div class="flex align-center " style="width: 100%" >
        <div class=""  >
          <van-image width="50px" height="50px" round fit="cover" :src=" url + data.avatar"
                     v-if="data.avatar" @click="showhead(data.avatar)">
            <template v-slot:error>
              <div class="headImageName" style="">{{headName}}</div>
            </template>
            <template v-slot:loading>
              <van-loading type="spinner" size="20" />
            </template>
          </van-image>
        <div class="headImage" v-else >
            <div class="headImageName" style="">{{headName}}</div>
        </div>
        </div >
        <div class=" text-left pl-1 py-1" style="width: 100%" >
            <div  class=" "   >
                 <span style="margin-right: 8px">{{data.nickName}}</span>
                <span class="TSlabel" style="background-color:#3ca31b" v-if="data.userType==3" >学生</span>
                <span class="TSlabel" style="background-color:cornflowerblue" v-if="data.userType==2" >教师</span>

              <div class="TSlabel text-ellipsis" style="color:#adadad;width:70%;height: 25px;font-size: 13px"  v-if="deptShow"  >{{data.deptName}}</div>
            </div>
            <div class="" style="color:#adadad;min-height:25px" >{{data.phonenumber}} <span v-if="data.cornet"  >/</span> {{data.cornet}}</div>
        </div>
        <div></div>
    </div>
</template>

<script>
import {ImagePreview} from "vant";

export default {
    props:{
        data:{
            type:Object,
            defalut:()=>{
                return {}
            }
        },
      deptShow:{
        type:Boolean,
        defalut:false
      },
    },
  data(){
      return{
        url:process.env.VUE_APP_BASE_API || '',
      }
  },
    computed:{
        headName(){
          let data =this.data
          if(!this.data.nickName){return }
            return data.nickName.substring(0,1).toUpperCase()
        }
    },
  methods:{
    showhead(data){
      // ImagePreview({
      //   images: [
      //     this.url+ data
      //   ],
      //   overlayStyle:{
      //
      //     backgroundColor:'rgba(0,0,0,75%)'
      //   },
      //   closeable: true,
      // });
    },
  }
}
</script>

<style>
    .headImage{
         width:50px;height:50px;border-radius:50%;background-color:#f3f3f3;
        }
    .headImageName{
        font-size:22px;font-weight: 500;
      line-height:50px;
      color:#adadad;
      text-align:center;
    }
</style>
